import { emptyTextValidationDirective } from './empty-text-validation.directive';

export const emptyTextValidation = angular
	.module('common.libs.emptyTextValidation', [])
	.directive('emptyTextValidation', emptyTextValidationDirective)
	.name;


// WEBPACK FOOTER //
// ./src/app/common/components/empty-text-validation/empty-text-validation.module.js